import { formatEntityId } from '../../../../../helpers';
import { TP_OPTIONS_MENU_ITEM_IDS, TP_OPTIONS_SUBMENU_IDS } from '../constants';
import { toClientOption } from '../utils';

import type { Bays } from '../../../../../utils/types';
import type { PdfDocumentProps } from '../pdfDocument';
import type { TpOptionsSubmenuId } from '../types';
import type {
  HeaderConfirmHandlers,
  HeaderDialogController,
  HeaderMenuHandlers,
  TreatmentPlanV3HeaderState,
  UseClientSelectResult,
  UsePlanActionsResult,
  UseProgressReportResult,
} from './types';

export function buildHeaderMenuHandlers(
  plan: UsePlanActionsResult,
  report: UseProgressReportResult,
): HeaderMenuHandlers {
  const onBayPick = (submenuId: TpOptionsSubmenuId, bay: Bays) => {
    if (submenuId === TP_OPTIONS_SUBMENU_IDS.CLONE_PLAN) {
      plan.requestClone(bay);
      return;
    }
    void plan.createBlankPlan(bay);
  };

  return {
    onItemClick: {
      [TP_OPTIONS_MENU_ITEM_IDS.EDIT]: plan.requestEdit,
      [TP_OPTIONS_MENU_ITEM_IDS.DELETE]: plan.requestDelete,
      [TP_OPTIONS_MENU_ITEM_IDS.VIEW_ACTIVATION]: plan.openActivation,
      [TP_OPTIONS_MENU_ITEM_IDS.ACTIVATE]: plan.requestActivate,
      [TP_OPTIONS_MENU_ITEM_IDS.DEACTIVATE]: plan.requestDeactivate,
      [TP_OPTIONS_MENU_ITEM_IDS.PROGRESS_REPORT]: () => {
        void report.requestReport();
      },
      [TP_OPTIONS_MENU_ITEM_IDS.DOWNLOAD]: plan.requestDownload,
    },
    onBayPick,
  };
}

export function buildHeaderConfirmHandlers(
  dialog: HeaderDialogController,
  clientSelect: UseClientSelectResult,
  plan: UsePlanActionsResult,
  report: UseProgressReportResult,
): HeaderConfirmHandlers {
  return {
    switchClient: clientSelect.confirmSwitchClient,
    clonePlan: plan.confirmClone,
    switchPlan: plan.confirmSwitchPlan,
    edit: plan.confirmEdit,
    editSuccess: dialog.closeDialog,
    delete: plan.confirmDelete,
    existingActive: plan.switchToActivePlan,
    activate: plan.confirmActivate,
    activated: dialog.closeDialog,
    deactivate: plan.confirmDeactivate,
    download: plan.confirmDownload,
    reportProgress: dialog.closeDialog,
    reportConfirm: report.print,
    noActivePlan: dialog.closeDialog,
  };
}

export function buildPdfDocumentProps(state: TreatmentPlanV3HeaderState): PdfDocumentProps {
  const { treatmentPlan, selectedClient, reportGoals, multiTrialSummary, recommendation } = state;
  return {
    data: multiTrialSummary,
    client: selectedClient ? toClientOption(selectedClient) : null,
    treatmentPlan:
      treatmentPlan?.id === undefined
        ? null
        : { id: treatmentPlan.id, label: formatEntityId(treatmentPlan.id) },
    goals: reportGoals,
    recommendation,
  };
}
